import * as React from 'react';
import './App.css';
import { Main } from './components/4-pages'

function App() {
  return (
    <Main />
  );
}

export default App;
